export const YouTube = () => (
  <svg height="100%" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M501.5,133.1c-5.9-21.9-23.2-39.2-45.1-45.1C416.3,77,256,77,256,77S95.7,77,55.7,87.5
	c-21.5,5.9-39.2,23.6-45.1,45.5C0,173.2,0,256.2,0,256.2s0,83.5,10.5,123.1c5.9,21.9,23.2,39.2,45.1,45.1c40.5,11,200.3,11,200.3,11
	s160.3,0,200.3-10.5c21.9-5.9,39.2-23.2,45.1-45.1C512,339.7,512,256.7,512,256.7S512.4,173.2,501.5,133.1z M205,333V179.5
	l133.3,76.8L205,333z"
      fill="#112CAE"
    />
  </svg>
);
